import { useState, useEffect } from "react";
import AnimatedLetters from "../AnimatedLetters";
import { AiFillCaretRight } from "react-icons/ai";
import { FiCircle } from "react-icons/fi";
import { IoIosSchool } from "react-icons/io";
import "./index.scss";

const About = () => {
    const [letterClass, setLetterClass] = useState("text-animate");
    const [timelineIndex, setTimelineIndex] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            setLetterClass("text-animate-hover");
        }, 4000);
        return () => {
            console.log("This will be logged on unmount");
        };
    }, []);

    const handleClick = (e) => {
        let idx = Number(e.target.id);
        console.log(timelineIndex, idx);
        if (timelineIndex - idx === -1) {
            // one forward
            let bars = document.getElementsByClassName("progress-bar");
            console.log(bars);
            if (
                document
                    .getElementsByClassName("progress-bar")
                    [idx - 1].classList.contains("progress-dec")
            ) {
                bars[idx - 1].classList.remove("progress-dec");
            }
            bars[idx - 1].classList.add("progress-inc");
            for (let i = 0; i < 3; i++) {
                if (Math.abs(i - idx) <= 1) {
                    document
                        .getElementById(`${i}`)
                        .classList.remove("progress-click-disabled");
                    document
                        .getElementById(`${i}`)
                        .classList.add("progress-click");
                } else {
                    document
                        .getElementById(`${i}`)
                        .classList.remove("progress-click");
                    document
                        .getElementById(`${i}`)
                        .classList.add("progress-click-disabled");
                }
            }

            // display carousel
            document
                .getElementById(`carousel_${idx - 1}`)
                .classList.remove("carousel-item");
            document
                .getElementById(`carousel_${idx - 1}`)
                .classList.add("carousel-item-disabled");
            document
                .getElementById(`carousel_${idx}`)
                .classList.remove("carousel-item-disabled");
            document
                .getElementById(`carousel_${idx}`)
                .classList.add("carousel-item");
        } else if (timelineIndex - idx === 1) {
            // one backward
            let bars = document.getElementsByClassName("progress-bar");
            bars[idx].classList.remove("progress-inc");
            bars[idx].classList.add("progress-dec");
            for (let i = 0; i < 3; i++) {
                if (Math.abs(i - idx) <= 1) {
                    document
                        .getElementById(`${i}`)
                        .classList.remove("progress-click-disabled");
                    document
                        .getElementById(`${i}`)
                        .classList.add("progress-click");
                } else {
                    document
                        .getElementById(`${i}`)
                        .classList.remove("progress-click");
                    document
                        .getElementById(`${i}`)
                        .classList.add("progress-click-disabled");
                }

                // display carousel
                document
                    .getElementById(`carousel_${idx + 1}`)
                    .classList.remove("carousel-item");
                document
                    .getElementById(`carousel_${idx + 1}`)
                    .classList.add("carousel-item-disabled");
                document
                    .getElementById(`carousel_${idx}`)
                    .classList.remove("carousel-item-disabled");
                document
                    .getElementById(`carousel_${idx}`)
                    .classList.add("carousel-item");
            }
        } else {
            // invalid click
            return;
        }
        setTimelineIndex(idx);
    };

    return (
        <div className="container about-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                        strArray={Array.from("About Me")}
                        idx={15}
                        letterClass={letterClass}
                    />
                </h1>
                <div className="subtext-zone">
                    <div className="progress-bars">
                        <FiCircle
                            className="progress-click"
                            id={`0`}
                            onClick={(e) => handleClick(e)}
                        />
                        <div class="progress">
                            <div class="progress-bar"></div>
                        </div>
                        <FiCircle
                            className="progress-click"
                            id={`1`}
                            onClick={(e) => handleClick(e)}
                        />
                        <div class="progress">
                            <div class="progress-bar"></div>
                        </div>
                        <FiCircle
                            className="progress-click-disabled"
                            id={`2`}
                            onClick={(e) => handleClick(e)}
                        />
                    </div>
                    <div className="carousel-container">
                        <div id={`carousel_0`} className="carousel-item">
                            <div className="carousel-item-text">
                                <h2>Education</h2>
                                <h3>
                                    B.Tech in Computer Science and Engineering
                                </h3>
                                <h4>Punjab Engineering College, Chandigarh</h4>
                                <p>
                                    Punjab Engineering College is a public
                                    research &amp; technical institution in
                                    Chandigarh. It was founded in 1921 in
                                    Lahore, established in Chandigarh in 1953,
                                    and focuses on the field of applied
                                    sciences, particularly engineering and
                                    technology.
                                </p>
                            </div>
                            <div className="carousel-item-img">
                                <img
                                    src="https://englishtribuneimages.blob.core.windows.net/gallary-content/2022/3/2022_3$largeimg_588448076.jpg"
                                    alt="PEC, Chandigarh"
                                />
                            </div>
                        </div>
                        <div
                            id={`carousel_1`}
                            className="carousel-item-disabled"
                        >
                            <div className="carousel-item-text">
                                <h2>Internship</h2>
                                <h3>Credit and Fraud Risk</h3>
                                <h4>American Express</h4>
                                <p>
                                    I worked as an intern with American Express
                                    India from January, 2022 to June, 2022 as an
                                    Analyst Intern. My work was related to UI
                                    automation and data anomaly analysis.
                                    American Express Company is an American
                                    multinational corporation specialized in
                                    payment card services headquartered at 200
                                    Vesey Street in the Battery Park City
                                    neighborhood of Lower Manhattan in New York
                                    City. The company was founded in 1850 and is
                                    one of the 30 components of the Dow Jones
                                    Industrial Average.
                                </p>
                            </div>
                            <div className="carousel-item-img">
                                <img
                                    src="https://i.pinimg.com/originals/c9/10/94/c910944ac6247ed2d0d47279453c5959.jpg"
                                    alt="American Express"
                                />
                            </div>
                        </div>
                        <div
                            id={`carousel_2`}
                            className="carousel-item-disabled"
                        >
                            <div className="carousel-item-text">
                                <h2>Internship</h2>
                                <h3>Web Development</h3>
                                <h4>RYD VISMAP Labs Pvt. Ltd.</h4>
                                <p>
                                    This was a short 1 month remote internship
                                    where I worked on the UI of ApnaStudy.com.
                                    ApnaStudy.com offered an effective and
                                    advanced technical solution that connected
                                    highly qualified teachers and professional
                                    trainers with learners across the globe and
                                    helped them through an unparalleled learning
                                    experience with an extra-ordinary tooling
                                    support.
                                </p>
                            </div>
                            <div className="carousel-item-img">
                                <img
                                    src="https://i.ytimg.com/vi/zJqEZ5uwO-c/maxresdefault.jpg"
                                    alt="ApnaStudy Logo"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
